import type { KitStatus } from '@cheqroom/api';

import type { KitInfoKit } from '../../../KitInfo.context';

type StatusText =
	| { key: KitStatus | 'unavailable' | 'unknown' }
	| { key: 'in_custody_with_link'; values: { inCustodyOf: string; userId: string } };

const KNOWN_STATUSES = new Set<string>([
	'available',
	'await_checkout',
	'checkedout',
	'empty',
	'expired',
	'in_custody',
	'incomplete',
] satisfies KitStatus[]);

interface Options {
	isUnavailable: boolean;
	canSeeUsers: boolean;
}

export const getKitStatusText = (
	kit: Pick<KitInfoKit, 'status' | 'items'>,
	{ isUnavailable, canSeeUsers }: Options
): StatusText => {
	// All items in the custody of one user: name that user. Otherwise a generic "In custody".
	const custodianIds = new Set(kit.items?.map((item) => item.custody?._id));
	const custodian = kit.items?.[0]?.custody;
	if (kit.status === 'in_custody' && canSeeUsers && custodianIds.size === 1 && custodian) {
		return { key: 'in_custody_with_link', values: { inCustodyOf: custodian.name, userId: custodian._id } };
	}

	if (isUnavailable) return { key: 'unavailable' };

	return { key: KNOWN_STATUSES.has(kit.status) ? kit.status : 'unknown' };
};
